"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SlideContainer = exports.HeroSlideBlock = exports.Line1Wrap = exports.Content = exports.Wrap = void 0;

var _helpers = require("./../../../../helpers");

var _uiKit = require("@dbi-tools/ui-kit");

var _heroSlide = require("../../hero-slide.styled");

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  padding: 0 15px;\n  max-width: ", "px !important;\n\n  ", "\n\n  ", " {\n    margin: auto;\n    max-width: ", "px !important;\n  }\n\n  ", " {\n    padding: 24px;\n    max-width: ", "px !important;\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  padding: 15px;\n\n  ", " {\n    padding: 10px;\n  }\n\n  ", " {\n    color: ", ";\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  text-align: center;\n  margin-bottom: 24px;\n  padding: 14px 10px;\n  position: relative;\n\n  ", " {\n    margin-bottom: 15px;\n  }\n\n  ", " {\n    padding: 8px 10px;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  margin-bottom: 15px;\n\n  ", " {\n    margin-bottom: 15px;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", " {\n    display: flex;\n    align-items: center;\n    height: ", ";\n    min-height: ", ";\n    justify-content: center;\n  }\n\n  ", " {\n    padding-top: 50px;\n    position: relative;\n    top: 100%;\n    transform: translateY(-100%);\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Wrap = (0, _uiKit.styled)('div')(_templateObject(), _uiKit.GridBreakpointsMediaUp.md, function (_ref) {
  var height = _ref.theme.height;
  return height ? "auto" : '100%';
}, function (_ref2) {
  var height = _ref2.theme.height;
  return height ? "".concat(height, "px") : 'auto';
}, _uiKit.GridBreakpointsMediaDown.sm);
exports.Wrap = Wrap;
var Content = (0, _uiKit.styled)('div')(_templateObject2(), _uiKit.GridBreakpointsMediaDown.md);
exports.Content = Content;
var Line1Wrap = (0, _uiKit.styled)('div')(_templateObject3(), _uiKit.Colors.secondary, _uiKit.GridBreakpointsMediaDown.md, _uiKit.GridBreakpointsMediaDown.sm);
exports.Line1Wrap = Line1Wrap;
var HeroSlideBlock = (0, _uiKit.styled)('div')(_templateObject4(), function (_ref3) {
  var bg = _ref3.bg;
  return bg ? _uiKit.Colors[bg] : _uiKit.Colors['transparent'];
}, _uiKit.GridBreakpointsMediaDown.sm, _heroSlide.Line1, _uiKit.Colors.gray800);
exports.HeroSlideBlock = HeroSlideBlock;
var SlideContainer = (0, _uiKit.styled)("div")(_templateObject5(), 342 + 60, function (_ref4) {
  var position = _ref4.position;
  return (0, _helpers.getContentPositioning)(position);
}, _uiKit.GridBreakpointsMediaDown.md, 327 + 60, _uiKit.GridBreakpointsMediaDown.sm, 327 + 48);
exports.SlideContainer = SlideContainer;